import { useFeature } from '@24i/nxg-sdk-smartott-shared/src/context/AppSettingsData';
import { useCallback, useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { usePurchaseData } from '@24i/nxg-sdk-smartott-shared/src/context/PurchaseData';
import { useAppNavigation } from '../../../../../context/AppNavigation';
import { SOTT_HOME_ROUTE } from '../../../../../navigation/constants';
import {
    getStripeCustomerPortalRedirectPage,
    removeStripeCustomerPortalRedirectPage,
    saveStripeCustomerPortalRedirectPage,
} from '../../../../../utils/navigation';
import { usePageShow } from '../../../../../hooks/usePageShow/index.web';

export const useViewModel = () => {
    const stripeSettings = useFeature('stripe');
    const inAppPurchases = useFeature('inAppPurchases')?.enabled || false;
    const purchaseDataClient = usePurchaseData();
    const router = useRouter();
    const { previousRoute } = useAppNavigation();
    const isRedirecting = useRef(false);

    const redirectToOriginalPage = useCallback(async () => {
        try {
            const redirectPage = await getStripeCustomerPortalRedirectPage();
            if (redirectPage) {
                isRedirecting.current = true;
                await router.push(redirectPage, redirectPage);
                await removeStripeCustomerPortalRedirectPage();
            }
        } catch (e) {
            isRedirecting.current = false;
        }
    }, [router]);

    usePageShow(redirectToOriginalPage);

    useEffect(() => {
        if (!previousRoute) {
            const navEntries = performance.getEntriesByType(
                'navigation'
            ) as PerformanceNavigationTiming[];
            const navType = navEntries[0]?.type as string;

            if (navType === 'back_forward') {
                redirectToOriginalPage();
            }
        }
    }, [previousRoute]);

    useEffect(() => {
        if (previousRoute) {
            saveStripeCustomerPortalRedirectPage(previousRoute);
        }
    }, [previousRoute]);

    useEffect(() => {
        if (inAppPurchases && stripeSettings?.enabled && !isRedirecting.current) {
            // check previous route to avoid redirect loop
            const previousPath =
                previousRoute && previousRoute !== router?.route ? previousRoute : SOTT_HOME_ROUTE;
            const goBackUrl = `${window.location.protocol}//${window.location.host}${previousPath}`;
            purchaseDataClient
                .getStripePortalSession({
                    goBackURL: goBackUrl,
                })
                .then((response) => {
                    if (isRedirecting.current) return;

                    const { customerPortalURL } = response;
                    if (customerPortalURL) window.location.href = customerPortalURL;
                });
        }
    }, [stripeSettings, inAppPurchases]);
};
